// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { OrganizationRole, OrganizationRoleSchema } from 'api/gen/OrganizationRole';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(OrganizationRoleSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelOrganizationRoleSchema = excess(requiredPart);

export interface PagedModelOrganizationRole extends t.TypeOf<typeof PagedModelOrganizationRoleSchema> {}
